exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login{width:100%;height:100%;background-image:url(https://file.iviewui.com/iview-admin/login_bg.jpg);background-size:cover;background-position:50%;position:relative}.login-con{position:absolute;right:160px;top:50%;transform:translateY(-60%);width:300px}.login-con-header{font-size:16px;font-weight:300;text-align:center;padding:30px 0}.login-con .form-con{padding:10px 0 0}.login-con .login-tip{font-size:10px;text-align:center;color:#c3c3c3}", ""]);

// exports
